module.exports = __webpack_public_path__ + "img/concierge.8c0a700c.jpg";